import { useLang } from 'hooks/lang';

import { Button, Card, Column, Label, Row } from 'components/Blocks';
import { CirclePlusIcon, EarthIcon } from 'components/Icons';

import { getCountryLabel } from 'utils/countries';

import { useProjectOption } from '../../options';

interface ProjectCountriesProps {
  children?: never;
  countries: string[];
}

export function ProjectCountries({ countries }: ProjectCountriesProps) {
  const { t } = useLang();

  const addCountry = useProjectOption('ADD_COUNTRY');

  return (
    <Column gap="2" className="px-2">
      <Row>
        <Label>
          <EarthIcon />
          {t('countries')}
        </Label>

        {addCountry.isEnabled && (
          <Button variant="ghost" size="small" onClick={addCountry.action} className="ml-auto">
            <CirclePlusIcon size={16} />
            <span className="phone:hidden">{t('add-country')}</span>
          </Button>
        )}
      </Row>

      <div className="grid grid-cols-auto-150 gap-4 text-center text-sm">
        {countries.map((country) => (
          <Card spacing="small" key={country}>
            {getCountryLabel(country)}
          </Card>
        ))}
      </div>
    </Column>
  );
}
